import { ApiResponse } from '../../../server/types.js';

export function unwrapResponse<T>(response: ApiResponse<T>): T {
  if (response.error) {
    // Convert the API error into a more detailed error object
    const error = new Error(response.error.error);
    Object.assign(error, {
      code: response.error.code,
      statusCode: response.error.statusCode,
      details: response.error.details
    });
    throw error;
  }
  
  if (!response.data) {
    throw new Error('Response missing data field');
  }
  
  return response.data;
} 